import { useEffect } from "react";
import Hero from "@/components/sections/Hero";
import BrandMarquee from "@/components/sections/BrandMarquee";
import Bestsellers from "@/components/sections/Bestsellers";
import USPSection from "@/components/sections/USPSection";
import HowItsMade from "@/components/sections/HowItsMade";
import FlavourExperience from "@/components/sections/FlavourExperience";
import SeeTheCrunch from "@/components/sections/SeeTheCrunch";
import AboutSection from "@/components/sections/AboutSection";
import WhyDignity from "@/components/sections/WhyDignity";
import TrustSection from "@/components/sections/TrustSection";
import ReviewsSection from "@/components/sections/ReviewsSection";
import InstagramSection from "@/components/sections/InstagramSection";
import CTASection from "@/components/sections/CTASection";
import ComboBuilder from "@/components/sections/ComboBuilder";
import VideoShowcase from "@/components/sections/VideoShowcase";

export default function Home() {
  useEffect(() => {
    document.title = "Dignity Food Kitchen — Big Crunch. Bold Flavour. | Protein-Rich Indian Snacks";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Premium protein-rich Indian snacks — soya nachos & chips in Piri Piri, Tango Tomato, Palak & Beetroot. Rich in iron, no preservatives, no artificial colours.");
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, []);

  return (
    <>
      <Hero />
      <BrandMarquee />
      <Bestsellers />
      <VideoShowcase />
      <USPSection />
      <FlavourExperience />
      <SeeTheCrunch />
      <ComboBuilder />
      <HowItsMade />
      <AboutSection />
      <WhyDignity />
      <TrustSection />
      <ReviewsSection />
      <InstagramSection />
      <CTASection />
    </>
  );
}
